import { HttpLink } from "apollo-link-http"
import { InMemoryCache } from "apollo-cache-inmemory"
import ApolloClient from "apollo-client"
import VueApollo from "vue-apollo"

import csrfToken from "bits/csrf_token"


const apolloClient = new ApolloClient({
  cache: new InMemoryCache(),
  link: new HttpLink({ 
    uri: "/api/graphql",
    credentials: "same-origin",
    headers: {
      "X-CSRF-Token": csrfToken,
      "X-UID": ww.uid
    }
  })
})

// Backward compatibility
const apolloProvider = new VueApollo({
  defaultClient: apolloClient
});


export { apolloClient, apolloProvider };